import styled from 'styled-components';

export const Footer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  background: white;
  border-top: 1px solid #e9ecef;
  button {
    border-radius: 0;
  }
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 12px 18px 16px;

  button {
    border-radius: 0;
    text-transform: uppercase;
  }
`;
